import { useContext, useEffect, useState } from "react";
import { api } from "../../../api";
import { SettingsSidebar } from "../../../externalComponents/SettingsSidebar";
import { PageHeading } from "../../../externalComponents/PageHeading";
import { OverflowFrame } from "../../../externalComponents";
import { CustomerContext } from "../../../providers";
import { Button } from "../../../externalComponents/tailwind/button";
import { Heading } from "../../../externalComponents/tailwind/heading";
import { Text } from "../../../externalComponents/tailwind/text";
import { Link } from "react-router-dom";
import { useGlobalAction } from "@gadgetinc/react";

export default function CompanyBillingPage() {
  const { customer } = useContext(CustomerContext);
  const [isLoading, setIsLoading] = useState(false);

  const [{ data, error, fetching }, getStripeInvoices] = useGlobalAction(
    api.getStripeInvoices
  );

  useEffect(() => {
    if (customer?.id) {
      getStripeInvoices({ customerId: customer.id });
    }
  }, [customer]);

  return (
    <>
      <SettingsSidebar>
        <PageHeading title="Billing" />
        <OverflowFrame>
          <div className="mt-5">
            <div className="mb-5">
              {!customer.isSubscribed && (
                <Button
                  loading={isLoading}
                  onClick={async () => {
                    setIsLoading(true);
                    const checkoutUrl = await api.createStripeCheckoutSession({
                      customerId: customer.id,
                    });
                    window.open(checkoutUrl, "_self");
                    setIsLoading(false);
                  }}
                >
                  Go to checkout
                </Button>
              )}
              {customer.isSubscribed && (
                <Heading>You are subscribed to Simio 🎉</Heading>
              )}
            </div>

            {(customer?.apiKey360Dialog || customer?.waAccessToken) && (
              <>
                <Button
                  color="secondaryButton"
                  onClick={() =>
                    window.open(
                      "https://business.facebook.com/wa/manage/phone-numbers/",
                      "_blank"
                    )
                  }
                >
                  View consumption on Meta
                </Button>
                <br />
                <br />
              </>
            )}
            {customer?.isStripeSubscribed && (
              <>
                {data && (
                  <>
                    <Text className="my-5 font-bold">Invoices</Text>
                    {data.map((i) => (
                      <div>
                        <Link
                          to={i.url}
                          target="_blank"
                          className="underline mb-1"
                        >
                          {i.date}
                        </Link>
                      </div>
                    ))}
                  </>
                )}
                <Button
                  className="mt-5"
                  color="secondaryButton"
                  onClick={() =>
                    window.open(
                      "https://billing.stripe.com/p/login/8wM28ggKr6XV4ve144",
                      "_blank"
                    )
                  }
                >
                  Update Plan
                </Button>
                <Text className="text-gray-500">
                  ⚠️ You must log in with the e-mail address you used for
                  payment.
                </Text>
              </>
            )}
          </div>
        </OverflowFrame>
      </SettingsSidebar>
    </>
  );
}
